import React from 'react';

const Loader = props => (
  <div
    className={`loader-wrapper ${props.className ? props.className : ''} ${
      props.active ? 'active' : ''
    }`}
  >
    {props.text && <span className="loader-caption">{props.text}</span>}
    <div className="spinner">
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./app/javascript/common/components/loader.js